import api, { DARTLEAGUE_API_URL } from '../api';

class QRAuthService {
  async ensureActiveSession() {
    return api.bootstrapSession();
  }

  async authenticateWithQR(qrData) {
    const user = api.getCurrentUser();

    if (!api.hasValidLocalSession() || !user?._id) {
      throw new Error('Debes iniciar sesión para escanear el QR');
    }

    try {
      const response = await api.authFetch(`${DARTLEAGUE_API_URL}/qr/authenticate`, {
        method: 'POST',
        headers: api.getHeaders(),
        body: JSON.stringify({
          qrData,
          userId: user._id,
        }),
      });

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(result.msg || result.message || 'No se pudo autenticar con el código QR');
      }

      return result;
    } catch (error) {
      console.error('Error autenticando con QR:', error);
      throw error;
    }
  }
}

const qrAuthService = new QRAuthService();

export default qrAuthService;
